module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'disable': !_vm.opened
    },
    attrs: {
      "id": "info-box"
    }
  }, [_c('div', {
    staticClass: "bar",
    on: {
      "mouseover": function($event) {
        _vm.opened = !_vm.opened
      }
    }
  }, [_c('div', {
    staticClass: "arrow"
  }, [(_vm.opened) ? _c('span', [_vm._v(" > ")]) : _c('span', [_vm._v(" < ")])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.body)
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5dae05ca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DataTableInfoBox.vue
// module id = 1304
// module chunks = 2